var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOldWheels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2606_83621)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2606_83621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5117 8.38281L13.4858 9.20312L15 8.38281L13.332 5.92188L12.5117 6.74219V8.38281Z",
    fill: "#CBB4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48828 8.38346L2.51416 9.20378L1 8.38346L3.04167 5.95898L3.48828 6.74284V8.38346Z",
    fill: "#CBB4FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2606_83621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2623 1.4082L8.90829 2.7799L8.2623 4.3367C7.55173 4.3367 6.90574 4.6274 6.43412 5.09249L4.74663 4.69699L4.37988 3.03826C5.37473 2.04343 6.75065 1.4082 8.2623 1.4082Z",
    fill: "#E64560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1441 3.03826L11.8194 4.65498L10.0899 5.09251C9.61828 4.6274 8.97229 4.3367 8.26172 4.3367V1.4082C9.77336 1.4082 11.1493 2.04343 12.1441 3.03826Z",
    fill: "#66B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7751 6.9215L12.3725 7.56749L10.8466 6.9215C10.8466 6.21089 10.5559 5.56489 10.0908 5.09332L12.1451 3.03906C13.1399 4.03389 13.7751 5.40986 13.7751 6.9215Z",
    fill: "#4D88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7751 6.91992C13.7751 8.43152 13.1399 9.80749 12.1451 10.8023L10.3595 10.3087L10.0908 8.74806C10.5559 8.27648 10.8466 7.63049 10.8466 6.91992H13.7751Z",
    fill: "#7ACC52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1446 10.8023C11.1498 11.7972 9.77385 12.4324 8.2622 12.4324L7.61621 10.9244L8.2622 9.50388C8.97277 9.50388 9.61877 9.21318 10.0904 8.74805L12.1446 10.8023Z",
    fill: "#ADE65C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2623 9.5039V12.4324C6.75065 12.4324 5.37473 11.7972 4.37988 10.8023L4.76203 9.12819L6.43414 8.74805C6.90574 9.2132 7.55173 9.5039 8.2623 9.5039Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43429 8.74952L4.38005 10.8038C3.38523 9.80895 2.75 8.43298 2.75 6.92138L4.29422 6.27539L5.6785 6.92138C5.6785 7.63195 5.9692 8.27795 6.43429 8.74952Z",
    fill: "#FFCB66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43429 5.0933C5.9692 5.56487 5.6785 6.21087 5.6785 6.92148H2.75C2.75 5.40983 3.38523 4.03387 4.38005 3.03906L6.43429 5.0933Z",
    fill: "#FF6666"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.38281V15H1V8.38281H6.38405L6.65471 9.20312H9.34529L9.61595 8.38281H15Z",
    fill: "#5A1B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.38281V15H8V9.20312H9.34529L9.61595 8.38281H15Z",
    fill: "#5A1B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94922 10.8438H10.0508V11.6641H5.94922V10.8438Z",
    fill: "#CBB4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.8438H10.0508V11.6641H8V10.8438Z",
    fill: "#CBB4FE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2606_83621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2606_83621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2606_83621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0249,
    height: 11.0249,
    fill: "white",
    transform: "translate(2.75 1.4082)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldWheels);
export default __webpack_public_path__ + "static/media/OldWheels.8280242a42578718edd0ea52ed5e1f10.svg";
export { ForwardRef as ReactComponent };